import type { FC } from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Fade from "@mui/material/Fade";
import { useTranslation } from "@privacy/translations";
import { HACK_alignIconWithLabel } from "@privacy/ui";
import { AlertCircleIcon, TriangleAlertIcon } from "../../shared/icons";

type ErrorMessageProps = {
  /** If no errorMessage is passed as prop we fallback to generic message */
  errorMessage?: string;
  variant?: "error" | "warning";
};

export const ErrorMessage: FC<ErrorMessageProps> = ({ errorMessage, variant = "error" }) => {
  const { t } = useTranslation();
  const Icon = variant === "warning" ? TriangleAlertIcon : AlertCircleIcon;

  return (
    <Fade in unmountOnExit>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          gap: 1,
          ml: 2,
          mt: 1,
          fontSize: theme => theme.typography.pxToRem(12),
          color: theme => (variant === "warning" ? theme.palette.warning.main : theme.palette.error.main),
        }}
      >
        <Icon size={12} />
        <Typography component="span" sx={{ ...HACK_alignIconWithLabel, fontSize: "inherit", color: "inherit" }}>
          {errorMessage ? errorMessage : t("DynamicForm.Inline.FailedToSave")}
        </Typography>
      </Stack>
    </Fade>
  );
};
